export const BASE_URL = import.meta.env.VITE_API_URL || '';


export const ERROR_CODES = {
  ERROR: '-1',
  WARNING: '0',
  SUCCESS: '1',
};

